// extracted by mini-css-extract-plugin
module.exports = {"link":"ArticleListItem_link__EslAm"};